import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { enumDetailedInfoPlacementEnum } from '@app/data-layer/enums/lcl';
import { LclShipmentCardModel } from '@data-layer/models/lcl/lcl-shipment-card.model';

@Component({
  selector: 'app-lcl-dashboard-shipment-card',
  templateUrl: './lcl-dashboard-shipment-card.component.html',
  styleUrls: ['./lcl-dashboard-shipment-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclDashboardShipmentCardComponent implements OnInit {
  @Input() public shipment: LclShipmentCardModel;

  public referenceTitleKey: string = 'LABELS.SHIPMENT';
  public enumDetailedInfoPlacementEnum: typeof enumDetailedInfoPlacementEnum = enumDetailedInfoPlacementEnum;

  constructor() {}

  public ngOnInit(): void {}
}
